import { getUserInfo } from "@/utils/user";
import { getToken } from "@/utils/token";

const getters = {
  sidebar: (state) => state.app.sidebar,
  language: (state) => state.app.language,
  size: (state) => state.app.size,
  device: (state) => state.app.device,
  visitedViews: (state) => state.tagsView.visitedViews,
  cachedViews: (state) => state.tagsView.cachedViews,
  user: () => getUserInfo(),
  token: () => getToken(),
  providerCopType: (state) => state.user.providerCopType,
  getPECommerce: (state, getters, rootState, rootGetters) => {
    return rootState.declareEnterpriseStore.enterpriseTypeGroup["电商平台"];
  },
  getEECommerce: (state, getters, rootState, rootGetters) => {
    return rootState.declareEnterpriseStore.enterpriseTypeGroup["电商企业"];
  },
  getAssureECommerce: (state, getters, rootState, rootGetters) => {
    return rootState.declareEnterpriseStore.assureEnterprise;
  },
  getCustomerList: (state, getters, rootState, rootGetters) =>
    rootState.customerStore.customerList,
  getMerchantList: (state, getters, rootState, rootGetters) =>
    rootState.merchantStore.merchantList,
  getAccountBookList: (state, getters, rootState, rootGetters) =>
    rootState.customsAccountBookStore.accountBookList,
  getEnterprise: (state, getters, rootState, rootGetters) => {
    return [
      {
        label: "电商企业",
        options:
          rootState.declareEnterpriseStore.enterpriseTypeGroup["电商企业"],
      },
      {
        label: "电商平台",
        options:
          rootState.declareEnterpriseStore.enterpriseTypeGroup["电商平台"],
      },
    ];
  },
  subChannelListForSH: () => {
    return [
      {
        value: "",
        label: "全部",
      },
    ];
  },
  subChannelList: (state, getters, rootState, rootGetters) => {
    return [
      { value: "", label: "全部" },
      { value: "121728", label: "喜荟母婴海外旗舰店" },
    ];
  },
  subChannelNameMapping(state, getters) {
    return {
      121728: "喜荟母婴海外旗舰店",
    };
  },
  subChannelNameMappingForSH(state, getters) {
    return {};
  },
  wmsOperationStatusMap() {
    return {
      "00": "创建订单",
      10: "部分预配",
      20: "预配完成",
      30: "部分分配",
      40: "分配完成",
      50: "部分拣货",
      60: "拣货完成",
      61: "播种完成",
      62: "部分装箱",
      63: "完全装箱",
      65: "部分装车",
      66: "装车完成",
      70: "部分发运",
      80: "完全发运",
      90: "订单取消",
      98: "等待释放",
      99: "订单完成",
    };
  },
  getTransMode: () => {
    return [
      { value: "0", label: "非保税区" },
      { value: "1", label: "监管仓库" },
      { value: "2", label: "水路运输" },
      { value: "3", label: "铁路运输" },
      { value: "4", label: "公路运输" },
      { value: "5", label: "航空运输" },
      { value: "6", label: "邮件运输" },
      { value: "7", label: "保税区" },
      { value: "8", label: "保税仓库" },
      { value: "9", label: "其他方式运输" },
      { value: "H", label: "边境特殊海关作业区" },
      { value: "T", label: "综合实验区" },
      { value: "W", label: "物流中心" },
      { value: "X", label: "物流园区" },
      { value: "Y", label: "保税港区" },
      { value: "Z", label: "出口加工区" },
      { value: "L", label: "旅客携带" },
      { value: "G", label: "固定设施运输" },
      { value: "S", label: "特殊综合保税区" }
    ];
  },
  getTradeMode: () => {
    return [
      { value: "0110", label: "一般贸易" },
      { value: "0130", label: "易货贸易" },
      { value: "0139", label: "旅游购物商品" },
      { value: "0200", label: "料件销毁" },
      { value: "0214", label: "来料加工" },
      { value: "0245", label: "来料料件内销" },
      { value: "0255", label: "来料深加工" },
      { value: "0258", label: "来料余料结转" },
      { value: "0265", label: "来料料件复出" },
      { value: "0300", label: "来料料件退换" },
      { value: "0314", label: "加工专用油" },
      { value: "0320", label: "不作价设备" },
      { value: "0345", label: "来料成品减免" },
      { value: "0400", label: "边角料销毁" },
      { value: "0420", label: "加工贸易设备" },
      { value: "0444", label: "保区进料成品" },
      { value: "0445", label: "保区来料成品" },
      { value: "0446", label: "加工设备内销" },
      { value: "0456", label: "加工设备结转" },
      { value: "0466", label: "加工设备退运" },
      { value: "0500", label: "减免设备结转" },
      { value: "0513", label: "补偿贸易" },
      { value: "0544", label: "保区进料料件" },
      { value: "0545", label: "保区来料料件" },
      { value: "0615", label: "进料对口" },
      { value: "0642", label: "进料以产顶进" },
      { value: "0644", label: "进料料件内销" },
      { value: "0654", label: "进料深加工" },
      { value: "0657", label: "进料余料结转" },
      { value: "0664", label: "进料料件复出" },
      { value: "0700", label: "进料料件退换" },
      { value: "0715", label: "进料非对口" },
      { value: "0744", label: "进料成品减免" },
      { value: "0815", label: "低值辅料" },
      { value: "0844", label: "进料边角料内销" },
      { value: "0845", label: "来料边角料内销" },
      { value: "0864", label: "进料边角料复出" },
      { value: "0865", label: "来料边角料复出" },
      { value: "1039", label: "市场采购" },
      { value: "1139", label: "国轮油物料" },
      { value: "1200", label: "保税间货物" },
      { value: "1210", label: "保税电商" },
      { value: "1215", label: "保税工厂" },
      { value: "1233", label: "保税仓库货物" },
      { value: "1234", label: "保税区仓储转口" },
      { value: "1239", label: "保税电商A" },
      { value: "1300", label: "修理物品" },
      { value: "1371", label: "保税维修" },
      { value: "1427", label: "出料加工" },
      { value: "1500", label: "租赁不满1年" },
      { value: "1523", label: "租赁贸易" },
      { value: "1616", label: "寄售代销" },
      { value: "1741", label: "免税品" },
      { value: "1831", label: "外汇商品" },
      { value: "2025", label: "合资合作设备" },
      { value: "2210", label: "对外投资" },
      { value: "2225", label: "外资设备物品" },
      { value: "2439", label: "常驻机构公用" },
      { value: "2600", label: "暂时进出货物" },
      { value: "2700", label: "展览品" },
      { value: "2939", label: "陈列样品" },
      { value: "3010", label: "货样广告品" },
      { value: "3039", label: "货样广告品Ｂ（已废止）" },
      { value: "3100", label: "无代价抵偿" },
      { value: "3239", label: "零售电商" },
      { value: "3339", label: "其他进出口免费" },
      { value: "3410", label: "承包工程进口" },
      { value: "3422", label: "对外承包出口" },
      { value: "3511", label: "援助物资" },
      { value: "3611", label: "无偿军援" },
      { value: "3612", label: "捐赠物资" },
      { value: "3910", label: "军事装备" },
      { value: "4019", label: "边境小额" },
      { value: "4039", label: "对台小额" },
      { value: "4139", label: "对台小额商品交易市场" },
      { value: "4200", label: "驻外机构运回" },
      { value: "4239", label: "驻外机构购进" },
      { value: "4400", label: "来料成品退换" },
      { value: "4500", label: "直接退运" },
      { value: "4539", label: "进口溢误卸" },
      { value: "4561", label: "退运货物" },
      { value: "4600", label: "进料成品退换" },
      { value: "5000", label: "料件进出区" },
      { value: "5010", label: "特殊区域研发货物" },
      { value: "5014", label: "区内来料加工" },
      { value: "5015", label: "区内进料加工货物" },
      { value: "5033", label: "区内仓储货物" },
      { value: "5034", label: "区内物流货物" },
      { value: "5100", label: "成品进出区" },
      { value: "5200", label: "区内边角调出" },
      { value: "5300", label: "设备进出区" },
      { value: "5335", label: "境外设备进区" },
      { value: "5361", label: "区内设备退运" },
      { value: "6033", label: "物流中心进出境货物" },
      { value: "9600", label: "内贸货物跨境运输" },
      { value: "9610", label: "电子商务" },
      { value: "9639", label: "海关处理货物" },
      { value: "9700", label: "后续补税" },
      { value: "9739", label: "其他贸易" },
      { value: "9800", label: "租赁征税" },
      { value: "9839", label: "留赠转卖物品" },
      { value: "9900", label: "其他" },
    ];
  },
};
export default getters;
